import { Component } from '@angular/core';
import { MenuComponent } from '../menu/menu.component';
import { MobileMenuComponent } from '../mobile-menu/mobile-menu.component';
import { RouterOutlet } from '@angular/router';
import { AlertToastStackComponent } from '../../components/alerts/components/alert-toast-stack/alert-toast-stack.component';

@Component({
  selector: 'app-main-page',
  standalone: true,
  imports: [MenuComponent, MobileMenuComponent, RouterOutlet, AlertToastStackComponent],
  templateUrl: './main-page.component.html',
  styleUrl: './main-page.component.scss'
})
export class MainPageComponent {}
